"use client";

import { useContext, useEffect, useState } from "react";
import { IReelResponse } from "@finbackoffice/clientbff-client";
import { Language, SiteContentScopes } from "@finbackoffice/enums";
import { ClientBFFContext, useRuntimeConfig } from "@finbackoffice/site-core";
import { useParams } from "next/navigation";

type IReelsDataState = {
    games: IReelResponse[];
    totalCount: number;
    loading: boolean;
};

export const useReels = (scope?: SiteContentScopes[]) => {
    const COMMON_SITE_CONFIGS = useRuntimeConfig("COMMON_SITE_CONFIGS");
    const client = useContext(ClientBFFContext);
    const { lang: locale } = useParams();

    const [gamesState, setGamesState] = useState<IReelsDataState>({
        games: [],
        totalCount: 0,
        loading: true,
    });

    useEffect(() => {
        const loadData = async () => {
            setGamesState((state) => ({
                ...state,
                loading: true,
            }));
            try {
                // const deviceTag = device === "desktop" ? PopupTags.Desktop : PopupTags.Mobile;
                const deviceTag = "mobile";

                let tags = [deviceTag, COMMON_SITE_CONFIGS.appName];

                if (scope) {
                    tags = [...tags, ...scope];
                }

                const response = await client.getReels({
                    language: locale as Language,
                    tags,
                });

                setGamesState((state) => ({
                    ...state,
                    games: response.items,
                    totalCount: response.total_count,
                    loading: false,
                }));
            } catch (_error: unknown) {
                setGamesState((state) => ({
                    ...state,
                    loading: false,
                }));
            }
        };

        void loadData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return { gamesState };
};
